/**
 * Dialog de confirmación: pagar batch agrupado por proveedor.
 * Extraído de CxPPanel.jsx en Iter 236.m.14 (Carlos) para reducir tamaño del
 * archivo padre. Garantizado por suite Playwright (specs/CxPPanel.spec.ts).
 */
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../ui/alert-dialog';

export function BatchPagarDialog({ open, busy, count, onClose, onConfirm }) {
  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && !busy && onClose()}>
      <AlertDialogContent data-testid="dialog-batch-pagar">
        <AlertDialogHeader>
          <AlertDialogTitle>
            Pagar {count} factura{count === 1 ? '' : 's'} agrupadas por proveedor
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="text-sm space-y-1">
              <p>
                Iter 234.c (Carlos): se creará <b>UN egreso por proveedor</b> en Alegra que cubrirá
                todas las facturas seleccionadas de ese proveedor (no un payment-out por factura).
              </p>
              <p>
                Las facturas se marcarán como <b>pagadas</b> en el ERP. Banco por defecto:
                <b> Banco de Chile 1</b>.
              </p>
              <p className="text-xs text-muted-foreground">
                El refresh del flujo se hace al final, una sola vez.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={busy} data-testid="btn-batch-pagar-cancel">
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault();
              onConfirm();
            }}
            disabled={busy}
            className="bg-emerald-600 hover:bg-emerald-700"
            data-testid="btn-batch-pagar-confirm"
          >
            {busy ? 'Procesando…' : `Sí, pagar ${count}`}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
